import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from '../../../components/Link';
import { SvgSurprisedGlen, SvgTv } from '../../../icons';
import { DetailsTopButtons } from '../details-top-buttons/details-top-buttons';
import css from './no-broadcast-view.module.scss';

interface NoBroadcastViewProps {
  channelId: string;
}

export function NoBroadcastView({ channelId }: NoBroadcastViewProps) {
  const { t } = useTranslation();

  return (
    <div className={css.container}>
      <DetailsTopButtons />
      <SvgSurprisedGlen />
      <div className={css.text}>
        <h1 className={css.title}>{t('program:no_broadcast_title')}</h1>
        <p className={css.description}>{t('program:no_broadcast_description')}</p>
      </div>
      <Link className={css.button} to={`/page/tv/${channelId}`}>
        {t('program:no_broadcast_button')}
        <SvgTv height={24} width={24} className={css.logo} />
      </Link>
    </div>
  );
}
